import * as yup from "yup";

export default yup.object().shape({
  name: yup.string().required("É necessário informar o nome."),
  email: yup
    .string()
    .required("É necessário informar um e-mail.")
    .email("E-mail inválido."),
});
